import { BISKO_METHODOLOGY_LOOKUP_MAP } from "../bisko/methodology-lookup";
import { GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP } from "../ghg-administration/methodology-lookup";
import { GPC_METHODOLOGY_LOOKUP_MAP } from "../gpc/methodology-lookup";
const buildEnergySourceIdByKey = (lookup) => {
    const idByKey = new Map();
    for (const sector of Object.values(lookup.sectors)) {
        for (const energySource of Object.values(sector.energySources ?? {})) {
            if (energySource.key)
                idByKey.set(energySource.key, energySource.id);
        }
    }
    return idByKey;
};
// EnergySource carries no methodologyId column, and one methodology can hold several
// rows for the same carrier concept (e.g. GHG-administration's fleet vs. commuting fuel
// rows) — so an id can only be resolved from the methodology's OWN lookup, never from a
// query that matches on key alone across every methodology-level row.
export const resolveEnergySourceIdFromLookup = (lookup, energySourceKey) => buildEnergySourceIdByKey(lookup).get(energySourceKey) ?? null;
const GPC_ENERGY_SOURCE_ID_BY_KEY = buildEnergySourceIdByKey(GPC_METHODOLOGY_LOOKUP_MAP);
const ADMINISTRATION_ENERGY_SOURCE_ID_BY_KEY = buildEnergySourceIdByKey(GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP);
const BISKO_ENERGY_SOURCE_ID_BY_KEY = buildEnergySourceIdByKey(BISKO_METHODOLOGY_LOOKUP_MAP);
const EMPTY_ENERGY_SOURCE_ID_BY_KEY = new Map();
export const resolveMethodologyEnergySourceIdByKey = (methodologyId) => {
    if (methodologyId === GPC_METHODOLOGY_LOOKUP_MAP.id)
        return GPC_ENERGY_SOURCE_ID_BY_KEY;
    if (methodologyId === GHG_ADMINISTRATION_METHODOLOGY_LOOKUP_MAP.id)
        return ADMINISTRATION_ENERGY_SOURCE_ID_BY_KEY;
    if (methodologyId === BISKO_METHODOLOGY_LOOKUP_MAP.id)
        return BISKO_ENERGY_SOURCE_ID_BY_KEY;
    return EMPTY_ENERGY_SOURCE_ID_BY_KEY;
};
export const resolveMethodologyEnergySourceId = (methodologyId, energySourceKey) => resolveMethodologyEnergySourceIdByKey(methodologyId).get(energySourceKey) ?? null;
